import client from './client';

const examDatesApi = {
  getUpcoming(limit = 6) {
    return client.get('/exam-dates', { params: { limit } }).then(r => r.data.data);
  },
};

export default examDatesApi;
